module.exports = __webpack_public_path__ + "img/new-logo-blue.8f580bfc.png";